<template>


  <div style="background: rgb(244, 244, 244); min-height: 80vh">

    <div class="goodsbox">
      <div class="main">
        <Empty :text="'没有相关商品哦'" v-show="shopList.length == 0"></Empty>
        <div class="goods_nav" v-show="shopList.length != 0" v-for="item in shopList" :key="item.id"
          @click="$router.push('/details/' + item.id)">
          <div class="goods_main">
            <img :src="item.front" class="goodsimg" alt />

            <div class="goodsname">{{ item.name }}</div>
            <div class="goodsprice">
              <em style="font-size: 14px">￥</em>
              {{ item.price }}
            </div>
            <div class="goods_foot">
              <Tag color="cyan" style="float: right">销量{{ item.sales }}</Tag>
              <Tag v-for="(item, index) in item.serve" :key="item" :color="color[index]" v-if="index < 2">{{ item }}
              </Tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paging" v-show="shopList.length != 0">
      <Page :total="Number(total)" :current="pageIndex" :page-size="Number(pageSize)" @on-change="pageChange" />
    </div>
    <!-- <div style="height:20px"></div> -->
  </div>

</template>

<script>
  import {
    getShop,
    getGroupShop
  } from "@/api/index";
  import {
    mapState,
  } from 'vuex'
  export default {
    data() {
      return {
        shopList: [],
        pageIndex: 1,
        total: "",
        color: window.config.serve_color,
      };
    },
    computed: {
      ...mapState(['pageSize']),
    },
    watch: {
      // 监听分组变化
      "$store.state.groupId": {
        deep: true,
        handler: function (newVal, oldVal) {
          if (newVal != oldVal) {
            this._getGroupShop(this.$store.state.groupId);
          }
        }
      },
      search(newVal, oldVal) {
        if (newVal != oldVal) {
          this._getShop(this.$route.query.wd);
        }
      },
      // 监听路由刷新
      // $route: {
      //   handler: function (val, oldVal) {
      //     window.location.reload();
      //   },
      //   // 深度观察监听
      //   deep: true,
      // },
    },
    created() {
      if (this.$route.query.wd) {
        this.$store.state.groupId = -1;
        this.$store.state.search = this.$route.query.wd
        this._getShop(this.$route.query.wd);
      }
      if (this.$route.query.group) {
        this.$store.state.groupId = this.$route.query.group;
        this._getGroupShop(this.$route.query.group);
      }

    },
    methods: {
      // 获取分类商品
      _getGroupShop(id) {
        getGroupShop({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          group: id,
        }).then((res) => {
          this.shopList = res.data.data;
          this.total = res.data.total;
        });
      },

      // 获取商品
      _getShop(name) {
        getShop({
          pageIndex: this.pageIndex,
          name: name,
        }).then((res) => {
          this.shopList = res.data.data;
          this.total = res.data.total;
        });
      },




      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this._getShop(this.$route.query.wd);
      },

    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";

  .page-template {
    background: #fff;



    .goodsbox {
      overflow: hidden;
      background: rgb(244, 244, 244);

      .main {
        margin: 0 auto;
        width: 100%;
        max-width: 1230px;

        .goods_title {
          border: 1px solid #ddd;
          height: 40px;
          font-size: 17px;
          line-height: 40px;
          padding: 0 10px;

          a {
            cursor: pointer;
            font-weight: 600;
          }
        }

        .goods_nav {
          width: 246px;
          height: 325px;
          border: solid 5px transparent;
          border-radius: 2px;
          float: left;
          margin-top: 5px;
          position: relative;

          .goods_main {
            width: 100%;
            height: 315px;
            border: solid 1px #ddd;
            border-radius: 2px;
            background-color: #fff;

            .goodsimg {
              display: block;
              width: 96%;
              height: 225px;
              cursor: pointer;
              margin: 2%;
              object-fit: cover;
              background-repeat: no-repeat;
              border-radius: 2px;
            }

            .goodsname {
              width: 65%;
              height: 45px;
              margin-left: 2%;
              font-size: 14px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              /* 行数 */
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .goodsprice {
              display: inline-block;
              position: absolute;
              right: 2%;
              top: 250px;
              font-size: 22px;
              color: red;
              font-weight: 600;
            }

            .goods_tool {
              border-top: 1px solid #ddd;
              font-size: 12px;
              height: 36px;

              .sales {
                float: left;
                width: 49%;
                height: 35px;
                line-height: 35px;
                text-align: center;
                color: #999;
              }
            }

            .goods_foot {
              margin: 2%;
              overflow: hidden;
            }
          }
        }
      }
    }

    .paging {
      text-align: center;
      margin-top: 20px;
      height: 50px;
    }

    .active {
      background: #0066ff;
      border-bottom: 1px solid #0066ff;
    }
  }
</style>